import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormRushSwitchField, {
  MxFormRushSwitchFieldProps
} from "@rf-l2/form/rush/MxFormRushSwitchField";
import React from "react";

interface MxFormL3RushSwitchFieldProps extends MxFormRushSwitchFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
function MxFormL3RushSwitchField(props: MxFormL3RushSwitchFieldProps) {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormRushSwitchField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
}

export default MxFormL3RushSwitchField;
